<div class="wrapper">
  <form [formGroup]="form">
    <div class="two-items">

      <div class="form-component">
        <mat-form-field>
          <mat-select
            formControlName="Layer"
            matTooltip="{{ 'configurations-fields.tooltips.Layer' | translate }}"
          >
            <mat-option *ngFor="let layer of layers" [value]="layer.Id"> {{ layer.Name }} ({{ layer.Slug }})
            </mat-option>
          </mat-select>
          <mat-placeholder>{{
            layers.length ? ('configurationTab.layer' | translate) : ('configurationTab.noLayer' | translate)
            }}</mat-placeholder>
        </mat-form-field>
        <mat-icon class="update-icon" mat-icon-button (click)="updateLayers()">sync</mat-icon>
      </div>

      <div class="form-component">
        <mat-form-field>
          <mat-select
            matTooltip="{{ 'configurations-fields.tooltips.ObjectType' | translate }}"
            formControlName="ObjectType"
          >
            <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>
            <mat-option *ngFor="let objectType of objectTypesOptions" [value]="objectType.value">
              {{ objectType.title | translate }}
            </mat-option>
          </mat-select>
          <mat-placeholder>{{ 'configurations-fields.ObjectType' | translate }}</mat-placeholder>
        </mat-form-field>
      </div>

    </div>

    <div class="two-items">
      <div class="form-component">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mat-form-field>
            <input
              matInput
              matTooltip="{{ 'configurations-fields.tooltips.Header' | translate }}"
              type="text"
              placeholder="{{ 'configurations-fields.Header' | translate }}"
              formControlName="Title"
              name="Header"
            />
            <button mat-button type="button" *ngIf="isTitleNotEmpty" matSuffix mat-icon-button aria-label="Clear"
                    (click)="clearTitle()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
      </div>

      <div class="form-component">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mat-form-field>
            <mat-select
              matTooltip="{{ 'configurations-fields.tooltips.TitleField' | translate }}"
              formControlName="TitleField"
            >
              <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>

              <mat-option *ngFor="let field of placeMarksFields.PrimaryFields; let i = index"
                          [value]="placeMarksFields.TableKeys[i]">
                {{ field }}
              </mat-option>
            </mat-select>
            <mat-placeholder>{{ 'configurations-fields.TitleField' | translate }}</mat-placeholder>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="two-items">
      <div class="form-component main-color"
           [ngClass]="{'until-symbols' : isDisplayForCurrentSourceType(configurationFields.UseVGisSymbols)}"
      >
        <mee-color-picker formControlName="MainColor"></mee-color-picker>
      </div>

      <ng-container
        *ngIf="isDisplayForCurrentSourceType(configurationFields.UseVGisSymbols)">
        <div class="form-component symbology">
          <label>{{ 'configurations-fields.tooltips.Symbology' | translate }}</label>
          <mat-button-toggle-group
            class="symbology-button-group"
            (change)="onChangeSymbology($event)"
            value="{{ node.UseVGisSymbols ? symbology.vGIS : symbology.arcGIS }}"
          >
            <mat-button-toggle class="arcGIS" [value]="symbology.arcGIS">
              <img
                *ngIf="node.GISSymbol"
                src="{{ 'data:image/jpeg;base64,' + node.GISSymbol }}"
                alt="ArcGIS symbol"
              />
              {{ 'ArcGIS' }}
            </mat-button-toggle>
            <mat-button-toggle class="vGIS" [value]="symbology.vGIS">
              <div
                class="vGIS-point"
                [ngStyle]="{ 'background-color': mainColor && mainColor.length ? mainColor : ' #9F9F9F' }"
              >
                <div class="vGIS-inside-point"></div>
              </div>
              {{ 'vGIS' }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </ng-container>
    </div>

    <p class="object-configuration-title">
      {{ 'configurations-fields.ObjectConfigurationTitle' | translate }}
    </p>


    <div class="two-items" formGroupName="ObjectTypeConfiguration">
      <div class="form-component">
        <mat-form-field>
          <mat-select
            matTooltip="{{ 'configurations-fields.tooltips.BoundingBoxShape' | translate }}"
            formControlName="BoundingBoxShape">
            <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>
            <mat-option *ngFor="let item of point3DShapesOptions; let i = index"
                        [value]="point3DShape[item]">{{ item }}</mat-option>
          </mat-select>
          <mat-placeholder>{{ 'configurations-fields.BoundingBoxShape' | translate }}</mat-placeholder>
        </mat-form-field>
      </div>

      <div class="form-component with-measurement">
        <mee-configuration-compound-input-new
          formControlName="UndergroundConnectorDepth"
          placeholder="{{ 'configurations-fields.UndergroundConnectorDepth' | translate }}"
          helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
        ></mee-configuration-compound-input-new>
      </div>
    </div>

    <div class="two-items">
      <div class="form-component with-measurement">
        <mee-configuration-compound-input-new
          formControlName="DefaultDepth"
          placeholder="{{ 'configurations-fields.DefaultDepth' | translate }}"
          helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
        ></mee-configuration-compound-input-new>
      </div>

      <div class="form-component with-measurement with-invert-value">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mee-configuration-compound-select-new
            [placeMarksFields]="placeMarksFields"
            formControlName="DepthField"
            placeholder="{{ 'configurations-fields.DepthField' | translate }}"
            helpTooltip="{{ 'configurations-fields.tooltips.DepthAltitude' | translate }}"
          ></mee-configuration-compound-select-new>
        </ng-container>
      </div>
    </div>

    <ng-container formGroupName="ObjectTypeConfiguration">
      <div class="two-items">
        <div class="form-component with-measurement">
          <mee-configuration-compound-input-new
            formControlName="BoundingBoxHeight"
            placeholder="{{ 'configurations-fields.BoundingBoxHeight' | translate }}"
            helpTooltip="{{ 'configurations-fields.tooltips.BoundingBoxHeight' | translate }}"
          ></mee-configuration-compound-input-new>
        </div>

        <div class="form-component with-measurement with-invert-value">
          <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
          <ng-container *ngIf="placeMarksFields">
            <mee-configuration-compound-select-new
              [placeMarksFields]="placeMarksFields"
              formControlName="BoundingBoxHeightField"
              placeholder="{{ 'configurations-fields.BoundingBoxHeightField' | translate }}"
              helpTooltip="{{ 'configurations-fields.tooltips.BoundingBoxHeightField' | translate }}"
            ></mee-configuration-compound-select-new>
          </ng-container>
        </div>
      </div>

      <div class="two-items">
        <div class="form-component with-measurement">
          <mee-configuration-compound-input-new
            formControlName="BoundingBoxWidth"
            placeholder="{{ 'configurations-fields.BoundingBoxWidth' | translate }}"
            helpTooltip="{{ 'configurations-fields.tooltips.BoundingBoxWidth' | translate }}"
          ></mee-configuration-compound-input-new>
        </div>

        <div class="form-component with-measurement with-invert-value">
          <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
          <ng-container *ngIf="placeMarksFields">
            <mee-configuration-compound-select-new
              [placeMarksFields]="placeMarksFields"
              formControlName="BoundingBoxWidthField"
              placeholder="{{ 'configurations-fields.BoundingBoxWidthField' | translate }}"
              helpTooltip="{{ 'configurations-fields.tooltips.BoundingBoxWidthField' | translate }}"
            ></mee-configuration-compound-select-new>
          </ng-container>
        </div>
      </div>

    </ng-container>

    <p class="additional-details-title">
      {{ 'configurations-fields.AdditionalDetails' | translate }}
    </p>

    <div class="two-items">
      <div class="form-component">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mat-form-field>
            <mat-select
              matTooltip="{{ tooltipTextForSubtypeField | translate }}"
              formControlName="SubtypeField"
            >
              <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>
              <mat-option *ngFor="let field of placeMarksFields.PrimaryFields; let i = index"
                          [value]="placeMarksFields.TableKeys[i]">
                {{ field }}
              </mat-option>
            </mat-select>
            <mat-placeholder>{{ 'configurations-fields.SubtypeField' | translate }}</mat-placeholder>
          </mat-form-field>
        </ng-container>
      </div>

      <div class="form-component">
        <mat-spinner [diameter]="60" class="preload" *ngIf="!placeMarksFields"></mat-spinner>
        <ng-container *ngIf="placeMarksFields">
          <mat-form-field>
            <mat-select
              matTooltip="{{ 'configurations-fields.tooltips.ExternalIdField' | translate }}"
              formControlName="ExternalIdField"
            >
              <mat-option [value]="null">{{ 'configurationTab.notSelected' | translate }}</mat-option>
              <mat-option *ngFor="let field of placeMarksFields.PrimaryFields; let i = index"
                          [value]="placeMarksFields.TableKeys[i]">
                {{ field }}
              </mat-option>
            </mat-select>
            <mat-placeholder>{{ 'configurations-fields.ExternalIdField' | translate }}</mat-placeholder>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="two-items">
      <div class="form-component">
        <mee-label-configuration
          formControlName="LabelConfiguration"
        ></mee-label-configuration>
      </div>

      <div class="form-component">
        <mee-info-card-image formControlName="PlacemarkImage"></mee-info-card-image>
      </div>
    </div>

    <div class="two-items">
      <div class="form-component">
        <mat-form-field>
          <mat-select
            matTooltip="{{ 'configurations-fields.tooltips.AltitudeMode' | translate }}"
            formControlName="AltitudeMode"
          >
            <mat-option *ngFor="let mode of altitudeModesOptions" [value]="mode.value">
              {{ mode.title | translate }}
            </mat-option>
          </mat-select>
          <mat-placeholder>{{ 'configurations-fields.AltitudeMode' | translate }}</mat-placeholder>
        </mat-form-field>
      </div>

      <div class="form-component toggle-only-second"
           *ngIf="isDisplayForCurrentSourceType(configurationFields.IsExcludedFromProcessing)">
        <mat-slide-toggle
          formControlName="IsExcludedFromProcessing"
          matTooltip="{{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}"
          color="primary"
        >
          {{ 'configurations-fields.tooltips.ExcludeFromProcessing' | translate }}
        </mat-slide-toggle>
      </div>
    </div>

  </form>
</div>
